import type { EmbeddedInsertContext as InsertContext } from "@intelligems/ig-types";
import type { ComponentMod } from "@src/store/slices/experienceBuilder/types";
import { createSlice } from "@reduxjs/toolkit";
import { actions } from "@src/store/slices/experienceBuilder/common/actions";
import type { IComponentState } from "@src/store/slices/experienceBuilder/component/types";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

const initialState: IComponentState = {};

const clearDraft = (_state: IComponentState) => initialState;

export const componentSlice = createSlice({
  name: "experienceBuilderComponent",
  initialState,
  reducers: (create) => ({
    _startInsertion: create.reducer<InsertContext>((state, action) => {
      state.insertContext = action.payload;
    }),
    _initDraft: create.reducer<ComponentMod>((state, action) => {
      state.draft = action.payload;
      state.initialDraft = action.payload;
    }),
    setDraft: create.reducer<ComponentMod | undefined>((state, action) => {
      state.draft = action.payload;
      if (state.draft && action.payload) {
        state.draft.groupId = action.payload.selector;
      }
    }),
    clearDraft: create.reducer(clearDraft),
    backToSelection: create.reducer((state) => {
      state.draft = undefined;
      state.initialDraft = undefined;
    }),
  }),
  extraReducers: (builder) => {
    builder.addCase(experienceBuilderSlice.actions.initBuilder, clearDraft);
    builder.addCase(actions.clearDraft, clearDraft);
  },
  selectors: {
    getInsertContext: (state) => state.insertContext,
    getDraft: (state) => state.draft,
    getInitialDraft: (state) => state.initialDraft,
    isActive: (state) => state.insertContext !== undefined,
    getPhase: (state) => {
      if (!state.insertContext) return undefined;
      return state.draft ? ("editing" as const) : ("selecting" as const);
    },
  },
});
